/* eslint-disable jsx-a11y/label-has-associated-control */
import {
  Avatar,
  DatePicker,
  Input,
  Modal,
  Select,
  Tooltip,
  Upload,
} from 'antd';
import { useChangeHandler } from '@/hooks';
import PropTypes from 'prop-types';
import React, { useEffect, useMemo, useState } from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { regexDescription, regexInput } from 'utils/regex';
import {
  createFloor,
  fetchFloor,
  modifyFloor,
  setFloor,
} from 'state/actions/floor';
import { imgUrl } from 'utils/url';
import { log } from 'utils';

import {
  createCategory,
  fetchCategories,
  modifyCategory,
  setCategory,
} from 'state/actions/categories';
import moment from 'moment';
import { ExportIcon } from 'assets/icon/dynamic';
import CategoryDropdown from 'components/CategoryDropdown';
import ModalCategoryForm from 'components/ModalCategoryForm';
import ModalFloorForm from 'components/ModalFloorForm';
import { fetchTags } from 'state/actions/tag';
import { Option } from 'antd/lib/mentions';
import dayjs from 'dayjs';
import _ from 'underscore';
import './PoiForm.css';
import './PoiForm.scss';
import DropdownWrapper from '../DropdownWrapper';
import { poisCleanUpForm } from '../../state/actions/pois';
import { filterAccess } from '../Report/utils';

const PoiForm = ({ poi, setPoi, action, success, history, id, error }) => {
  const { siteId, siteName } = useParams();
  log(error);

  const [isDragged, setIsDragged] = useState(false);
  const [errors, setErrors] = useState(error);
  const [tempSelectedCategory, setTempSelectedCategory] = useState();
  const [tempSelectedCategories, setTempSelectedCategories] = useState([]);
  const [modalCategory, setModalCategory] = useState(false);
  const [playlistOpen, setPlaylistOpen] = useState(false);
  const [tempSelectedFloor, setTempSelectedFloor] = useState();
  const [tempSelectedFloors, setTempSelectedFloors] = useState([]);
  const [modalFloor, setModalFloor] = useState(false);
  const [floorOpen, setFloorOpen] = useState(false);
  const [firstList, setFirstList] = useState([]);
  const [secondList, setSecondList] = useState([]);
  const [previewList, setPreviewList] = useState([]);
  const [secondPreviewList, setSecondPreviewList] = useState([]);
  const [previewImage, setPreviewImage] = useState('');
  const [previewVisible, setPreviewVisible] = useState(false);
  const [previewTitle, setPreviewTitle] = useState('');
  const [updated, setUpdated] = useState(false);

  useEffect(() => {
    setErrors(error);
  }, [error]);

  const {
    loading,
    userData,
    siteList,
    categoriesList,
    subCategoryList,
    floorList,
    category,
    tagList,
    shapeList,
    model3dList,
    floor,
  } = useSelector(
    (state) => ({
      loading: state.pois.loading,
      userData: state.auth.userData,
      siteList: state.sites.list,
      categoriesList: state.categories.list,
      subCategoryList: state.subcategories.list,
      floorList: state.floor.list,
      tagList: state.tags.list,
      shapeList: state.editors.shapeList,
      model3dList: state.editors.model3dList,
      category: state.categories.category,
      floor: state.floor.floor,
    }),
    shallowEqual
  );

  const site = siteList?.find((site) => site._id === siteId);

  const uid = userData.id;

  const dispatch = useDispatch();

  if (poi) {
    log(poi, '<<<< POI');
  }

  useEffect(() => {
    if (success) {
      history.push(`/${siteId}/information/${siteName}`);
    }
  }, [success]); // eslint-disable-line

  useEffect(() => {
    return () => dispatch(poisCleanUpForm());
  }, [dispatch]);


  useEffect(() => {
    // fetch floor and poi categories
    dispatch(fetchFloor({ siteId }));
    dispatch(fetchTags({ siteId }));
    dispatch(fetchCategories({ siteId }));
  }, [siteId]); // eslint-disable-line

  useEffect(() => {
    if (poi) {
      log(poi);
      setTempSelectedCategories(
        ((poi.categoryIds && poi.categoryIds.length === 0) && poi.categoryId) ? [poi.categoryId] : poi.categoryIds
      );

      // Initialize tempSelectedFloors based on whether site supports multiple floors
      if (site?.canHaveMultipleFloor) {
        // For multiple floor mode, use floorIds or convert floorId to array
        const floors = poi.floorIds || (poi.floorId ? [poi.floorId] : []);
        setTempSelectedFloors(floors);
      } else {
        // For single floor mode, just set the single floor
        setTempSelectedFloors(poi.floorId ? [poi.floorId] : []);
      }

      if ( (poi.categoryIds && poi.categoryIds.length === 0) && poi.categoryId) {
        setPoi({
          ...poi,
          categoryIds: [poi.categoryId],
        });
      }

      // Convert between single and multiple floor formats if needed
      if (site?.canHaveMultipleFloor && poi.floorId && !poi.floorIds) {
        // Site supports multiple floors but POI only has floorId - convert it
        const floorName = floorList.find((f) => f._id === poi.floorId)?.name;
        setPoi({
          ...poi,
          floorIds: [poi.floorId],
          floorNames: floorName ? [floorName] : [],
        });
      } else if (!site?.canHaveMultipleFloor && poi.floorIds && !poi.floorId) {
        // Site doesn't support multiple floors but POI has floorIds - convert to single
        setPoi({
          ...poi,
          floorId: poi.floorIds[0],
          floorName: floorList.find((f) => f._id === poi.floorIds[0])?.name,
        });
      }
      if (poi.firstMedias && poi.secondMedias) {
        if (poi.firstMedias && !updated) {
          const images = [];
          poi.firstMedias.map((image, i) => {
            if (image) {
              images.push({
                uid: i,
                name: `${image}`,
                status: 'done',
                url: `${imgUrl}/poi/${image}`,
              });
            }
            return image;
          });
          setPreviewList(images);
        }
        if (poi.secondMedias && !updated) {
          const images = [];
          poi.secondMedias.map((image, i) => {
            if (image) {
              images.push({
                uid: i,
                name: `${image}`,
                status: 'done',
                url: `${imgUrl}/poi/${image}`,
              });
            }
            return image;
          });
          console.log(images, 'images');
          setSecondPreviewList(images);
        }
        setUpdated(true);
      }
    }
    // eslint-disable-next-line
  }, [poi, site, floorList]);

  const onChangeHandler = useChangeHandler(setPoi);

  const onFileChangedHandler = (file) => {
    setPoi((prevState) => ({ ...prevState, file, logoUrl: null }));
  };

  const handleDeletePreviewImage = () => {
    setPoi((prevState) => ({
      ...prevState,
      file: null,
      logoUrl: null,
      logo: null,
    }));
  };

  const onSubmitHandler = (event) => {
    console.log(poi);
    event.preventDefault();
    if (

      (!regexInput(poi.phone) && poi.phone) ||
      (!regexInput(poi.priority) && poi.priority) ||
      // (!regexUrl(poi.url) && poi.url) ||
      (!regexInput(poi.location) && poi.location) ||
      (!regexDescription(poi.description) && poi.description) ||
      (!regexInput(poi.floor) && poi.floor)
    ) {
      const newErrors = {
        ...errors,
        errors: {
          ...errors.errors,
        },
        message: 'Something went wrong!',
      };



      newErrors.errors.phone = !regexInput(poi.phone) &&
        poi.phone && [
          {
            msg: 'This field cannot contain any special characters',
          },
        ];

      newErrors.errors.priority = !regexInput(poi.priority) &&
        poi.priority && [
          { msg: 'This field cannot contain any special characters' },
        ];
      // newErrors.errors.url = !regexUrl(poi.url) &&
      //   poi.url && [{ msg: 'This field cannot contain any special characters' }];
      newErrors.errors.location = !regexInput(poi.location) &&
        poi.location && [
          { msg: 'This field cannot contain any special characters' },
        ];
      newErrors.errors.opentime = !regexInput(poi.opentime) &&
        poi.opentime && [
          { msg: 'This field cannot contain any special characters' },
        ];
      newErrors.errors.phone = !regexInput(poi.phone) &&
        poi.phone && [
          { msg: 'This field cannot contain any special characters' },
        ];
      newErrors.errors.description = !regexDescription(poi.description) &&
        poi.description && [
          { msg: 'This field cannot contain any special characters' },
        ];
      newErrors.errors.floor = !regexInput(poi.floor) &&
        poi.floor && [
          { msg: 'This field cannot contain any special characters' },
        ];

      setErrors(newErrors);
    } else {
      console.log(poi, 'poi');
      dispatch(
        action({
          uid,
          ...poi,
          start: poi.start && moment(poi.start).format(),
          end: poi.end && moment(poi.end).format(),
          siteId,
          id,
        })
      );
    }
  };

  const onSelectCategoryHandler = () => {
    // const categoryId = value.value;
    // const categoryName = value.label;
    setPoi((prevState) => ({
      ...prevState,
      categoryId: tempSelectedCategory,
      categoryName: categoriesList.find(
        (cat) => cat._id === tempSelectedCategory
      )?.name,
      categoryIds:[tempSelectedCategory]
    }));
    setPlaylistOpen(false);
  };
  const onSelectCategoriesHandler = () => {
    // const categoryId = value.value;
    // const categoryName = value.label;
    console.log(tempSelectedCategories, 'temp selected category')
    setPoi((prevState) => ({
      ...prevState,
      categoryIds: tempSelectedCategories,
      categoryId: tempSelectedCategories[0],
      categoryName: categoriesList.find(
        (cat) => cat._id === tempSelectedCategories[0]
      )?.name,
    }));
    setPlaylistOpen(false);
  };


  const onSelectFloorHandler = () => {
    // const floorId = value.value;
    // const floorName = value.label;
    setPoi((prevState) => ({
      ...prevState,
      floorId: tempSelectedFloor,
      floorName: floorList.find((floor) => floor._id === tempSelectedFloor)
        ?.name,
    }));
    setFloorOpen(false);
  };

  const onSelectFloorsHandler = () => {
    const selectedFloorObjects = floorList.filter((floor) =>
      tempSelectedFloors.includes(floor._id)
    );
    const floorNames = selectedFloorObjects.map((floor) => floor.name);

    setPoi((prevState) => ({
      ...prevState,
      floorIds: tempSelectedFloors,
      floorNames: floorNames,
      floorId: tempSelectedFloors[0],
      floorName: selectedFloorObjects[0]?.name,
    }));
    setFloorOpen(false);
  };

  const handleAddTempFloor = (floorId) => {
    const newFloors = [...tempSelectedFloors];
    const findFloor = newFloors.find((floor) => floor === floorId);
    if (findFloor) {
      const updateFloors = newFloors.filter((floor) => floor !== floorId);
      setTempSelectedFloors(updateFloors);
    } else {
      setTempSelectedFloors([...tempSelectedFloors, floorId]);
    }
  };

  // const canSubmit = poi.name && poi.description;

  const imagePreviewUrl = poi.file
    ? poi.file && URL.createObjectURL(poi.file)
    : poi.logo && `${imgUrl}/poi/${poi.logo}`;

  // const goBackMessage = useFormatMessage('PoiForm.goBack');

  // const pickAnotherFileMessage = useFormatMessage('PoiForm.pickAnotherFile');
  // const pickFileMessage = useFormatMessage('PoiForm.pickFile');

  const handleChangeDate = ([start, end]) => {
    setPoi({
      ...poi,
      start: start ? start.format() : null,
      end: end ? end.format() : null,
    });
  };

  const getCategory = (categoryId) => {
    const findCategory = categoriesList.find((cat) => cat._id === categoryId);
    return findCategory?.name;
  };

  const handleNew = () => {
    dispatch(
      setCategory(
        {
          _id: '',
          name: '',
          description: '',
          siteId: '',
          modifiedAt: new Date().toDateString(),
          modifiedBy: '',
        },
        () => setModalCategory(true)
      )
    );
  };

  const handleNewFloor = () => {
    dispatch(
      setFloor(
        {
          _id: '',
          name: '',
          description: '',
        },
        () => setModalFloor(true)
      )
    );
  };

  const onSubmitCategory = () => {
    const action = category._id ? modifyCategory : createCategory;

    dispatch(
      action({ ...category, siteId, id: category._id, uid }, () =>
        setModalCategory(false)
      )
    );
  };

  const handleSetCategory = (data) => {
    dispatch(setCategory(data));
  };

  const onSubmitFloor = () => {
    const action = floor._id ? modifyFloor : createFloor;

    dispatch(
      action({ uid, ...floor, siteId, id: floor._id }, () =>
        setModalFloor(false)
      )
    );
  };

  const handleSetFloor = (data) => {
    dispatch(setFloor(data));
  };

  const getFloor = (floorId) => {
    const findFloor = floorList.find((floor) => floor._id === floorId);
    return findFloor?.name;
  };

  const getFloors = (floorIds) => {
    if (!floorIds || floorIds.length === 0) return 'Select Floors';
    return _.pluck(
      floorList.filter((floor) => floorIds?.includes(floor._id)),
      'name'
    ).join(', ');
  };

  const onFileListChangedHandler = ({ file, params, setList, list }) => {
    setList([...list, file]);
    setPoi((prevState) => ({ ...prevState, [params]: [...list, file] }));
  };

  const handleAddTempCategory = (catId) => {
    const newCat = [...tempSelectedCategories];
    const findCat = newCat.find((cat) => cat === catId);
    if (findCat) {
      const updateCat = newCat.filter((cat) => cat !== catId);
      setTempSelectedCategories(updateCat);
    } else {
      setTempSelectedCategories([...tempSelectedCategories, catId]);
    }
  };

  const handleChange = ({ fileList, setPreview }) => {
    const updatedFile = fileList.map((fileRaw) => {
      const f = { ...fileRaw };
      if (f.status !== 'uploading') {
        f.status = 'done';
      }
      f.response = f.name;
      return f;
    });
    setPreview(updatedFile);
  };

  const handlePreview = async (f) => {
    const file = { ...f };
    if (!file.url && !file.preview) {
      file.preview = await getBase64(file.originFileObj);
    }
    setPreviewImage(file.url || file.preview);
    setPreviewVisible(true);
    setPreviewTitle(
      file.name || file.url.substring(file.url.lastIndexOf('/') + 1)
    );
  };

  const handleRemove = ({ e, params, poiParams, setList, list }) => {
    const images =
      poi[poiParams] && poi[poiParams].filter((image) => image !== e.name);
    const fImages = list.filter((f) => f.uid !== e.uid);
    setList(fImages);
    setPoi((prevState) => ({
      ...prevState,
      [poiParams]: images,
      [params]: fImages,
    }));
  };

  const getBase64 = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);

      reader.onload = () => resolve(reader.result);

      reader.onerror = (err) => reject(err);
    });

 const handleCancel = () => setPreviewVisible(false);
  const transformPoiLocationsToSelectValue = (locationsArray) => {
    if (!Array.isArray(locationsArray)) {
      return [];
    }
    return locationsArray.map(locObj => {
      if (locObj && locObj.id && locObj.type) {
        return `${locObj.type}_${locObj.id}`;
      }
      return null; // Filter out any invalid items
    }).filter(Boolean); // Remove nulls/undefineds
  };

  // Memoize the value prop for performance, recalculating only when poi.locations changes
  const selectValue = useMemo(() => {
    return transformPoiLocationsToSelectValue(poi.locations);
  }, [poi.locations]);


  // New onChange handler: transforms the selected strings back into objects
  const handleLocationChange = (selectedEncodedValues) => {
    const newLocations = selectedEncodedValues.map(encodedString => {
      // Example encodedString: "shape_67f377ef14c03d7b8cb513f3" or "model3d_some_model_id"
      const parts = encodedString.split('_');

      if (parts.length >= 2) {
        const type = parts[0]; // e.g., "shape" or "model3d"
        // The ID might contain underscores, so join the rest of the parts
        const id = parts.slice(1).join('_'); // e.g., "67f377ef14c03d7b8cb513f3" or "some_model_id"

        return { id, type };
      }

      console.warn(`Malformed encoded string from Select: ${encodedString}`);
      return null; // Return null for any string that doesn't fit the expected format
    }).filter(Boolean); // Filter out any nulls from malformed strings

    // Update the parent component's state with the new array of {id, type} objects
    setPoi({ ...poi, locations: newLocations });
  };

  console.log(poi, categoriesList, 'category')
  return (
    <div className="poi-form">
      <ModalCategoryForm
        visible={modalCategory}
        onCancel={() => setModalCategory(false)}
        onCreate={onSubmitCategory}
        category={category}
        setCategory={handleSetCategory}
        isEditing={!!category._id}
      />
      <ModalFloorForm
        visible={modalFloor}
        onCancel={() => {
          setModalFloor(false);
        }}
        onCreate={onSubmitFloor}
        floor={floor}
        setFloor={handleSetFloor}
        isEditing={!!floor._id}
      />
      <form className="form-wrapper">
        <div>
          <div className="form">
            <label className="form-label">
              Name <span className="is-required">*</span>
            </label>
            <Input
              placeholder="POI Name"
              className={`${
                errors && errors.errors && errors.errors.name ? 'has-error' : ''
              }`}
              name="name"
              value={poi.name}
              onChange={onChangeHandler}
            />
            {errors && errors.errors && errors.errors.name && (
              <span className="error-message">{errors.errors.name[0].msg}</span>
            )}
          </div>

          {site?.isAdsum ? (
            <div className="form">
              <label className="form-label">
                Poi Category <span className="is-required">*</span>
              </label>
              <DropdownWrapper
                setIsOpen={setPlaylistOpen}
                isOpen={playlistOpen}
                label={'Playlist'}
                getItemLabel={() =>
                  _.pluck(
                    categoriesList.filter((cat) =>
                      poi.categoryIds?.includes(cat._id)
                    ),
                    'name'
                  ).join(', ')
                }
                selectedItem={
                  poi.categoryIds?.length === 0 ? 'all' : poi.categoryIds
                }
              >
                <CategoryDropdown
                  categories={categoriesList}
                  setTempSelectedCategory={(catId) =>
                    handleAddTempCategory(catId)
                  }
                  handleSetPlaylist={onSelectCategoriesHandler}
                  tempSelectedCategory={tempSelectedCategories}
                  modalOpen={playlistOpen}
                />
              </DropdownWrapper>
              {errors && errors.errors && errors.errors.categoryId && (
                <span className="error-message">
                  {errors.errors.categoryId[0].msg}
                </span>
              )}
            </div>
          ) : (
            <div className="form">
              <label className="form-label">
                Poi Category <span className="is-required">*</span>
              </label>
              <DropdownWrapper
                setIsOpen={setPlaylistOpen}
                isOpen={playlistOpen}
                label={'Playlist'}
                getItemLabel={() => getCategory(poi.categoryId)}
                selectedItem={poi.categoryId ?? 'all'}
              >
                <CategoryDropdown
                  categories={categoriesList}
                  setTempSelectedCategory={(id) => setTempSelectedCategory(id)}
                  handleSetPlaylist={onSelectCategoryHandler}
                  tempSelectedCategory={tempSelectedCategory}
                  handleNew={
                    filterAccess({
                      userData,
                      siteId,
                      param: 'category',
                      action: 'create',
                    })
                      ? handleNew
                      : null
                  }
                  modalOpen={playlistOpen}
                />
              </DropdownWrapper>
              {errors && errors.errors && errors.errors.categoryId && (
                <span className="error-message">
                  {errors.errors.categoryId[0].msg}
                </span>
              )}
            </div>
          )}

          {(poi.categoryId ||
            (poi.categoryIds && poi.categoryIds?.length > 0)) && (
            <div className="form">
              <label className="form-label">Sub Categories</label>
              <Select
                mode="multiple"
                optionLabelProp="label"
                value={poi.subCategoryIds || []}
                filterOption={(input, opt) =>
                  (opt?.label ?? '').toLowerCase().includes(input.toLowerCase())
                }
                onChange={(e) => setPoi({ ...poi, subCategoryIds: e })}
              >
                {subCategoryList
                  .filter(
                    (sub) =>
                      poi.categoryIds?.includes(sub.categoryId) ||
                      poi.categoryId === sub.categoryId
                  )
                  .map((subCat) => (
                    <Option
                      key={subCat._id}
                      value={subCat._id}
                      label={subCat.name}
                    >
                      <div className="option-tag">{subCat.name}</div>
                    </Option>
                  ))}
              </Select>

              {errors && errors.errors && errors.errors.location && (
                <span className="error-message">
                  {errors.errors.location[0].msg}
                </span>
              )}
            </div>
          )}

          {site?.canHaveMultipleFloor ? (
            <div className="form">
              <label className="form-label">
                Floor <span className="is-required">*</span>
              </label>
              <DropdownWrapper
                setIsOpen={setFloorOpen}
                isOpen={floorOpen}
                label={'Floor'}
                getItemLabel={() => getFloors(poi.floorIds)}
                selectedItem={
                  poi.floorIds?.length === 0 ? 'all' : poi.floorIds
                }
              >
                <CategoryDropdown
                  categories={floorList}
                  setTempSelectedCategory={(floorId) =>
                    handleAddTempFloor(floorId)
                  }
                  handleSetPlaylist={onSelectFloorsHandler}
                  tempSelectedCategory={tempSelectedFloors}
                  handleNew={
                    filterAccess({
                      userData,
                      siteId,
                      param: 'floor',
                      action: 'create',
                    })
                      ? handleNewFloor
                      : null
                  }
                  modalOpen={floorOpen}
                  title="Floor"
                />
              </DropdownWrapper>
              {errors && errors.errors && errors.errors.floorId && (
                <span className="error-message">
                  {errors.errors.floorId[0].msg}
                </span>
              )}
            </div>
          ) : (
            <div className="form">
              <label className="form-label">
                Floor <span className="is-required">*</span>
              </label>

              <DropdownWrapper
                setIsOpen={setFloorOpen}
                isOpen={floorOpen}
                label={'Floor'}
                getItemLabel={() => getFloor(poi.floorId)}
                selectedItem={poi.floorId ?? 'all'}
              >
                <CategoryDropdown
                  categories={floorList}
                  setTempSelectedCategory={(id) => setTempSelectedFloor(id)}
                  handleSetPlaylist={onSelectFloorHandler}
                  tempSelectedCategory={tempSelectedFloor}
                  handleNew={
                    filterAccess({
                      userData,
                      siteId,
                      param: 'floor',
                      action: 'create',
                    })
                      ? handleNewFloor
                      : null
                  }
                  modalOpen={floorOpen}
                  title="Floor"
                />
              </DropdownWrapper>
              {errors && errors.errors && errors.errors.floorId && (
                <span className="error-message">
                  {errors.errors.floorId[0].msg}
                </span>
              )}
            </div>
          )}

          <div className="form">
            <label className="form-label">Tags</label>
            <Select
              mode="multiple"
              optionLabelProp="label"
              value={poi.tags || []}
              filterOption={(input, opt) =>
                (opt?.label ?? '').toLowerCase().includes(input.toLowerCase())
              }
              onChange={(e) => setPoi({ ...poi, tags: e })}
            >
              {tagList.map((tag) => (
                <Option key={tag._id} value={tag._id} label={tag.name}>
                  <div className="option-tag">
                    <Avatar size="small" src={`${imgUrl}/tag/${tag.logo}`} />{' '}
                    {tag.name}
                  </div>
                </Option>
              ))}
            </Select>

            {errors && errors.errors && errors.errors.tags && (
              <span className="error-message">{errors.errors.tags[0].msg}</span>
            )}
          </div>
          {site?.isWayfinding ? (
            <div className="form">
              <label className="form-label">Link to AdSign Editor CMS</label>
              <Select
                mode="multiple"
                optionLabelProp="label"
                value={selectValue}
                filterOption={(input, opt) =>
                  (opt?.label ?? '').toLowerCase().includes(input.toLowerCase())
                }
                onChange={handleLocationChange}
              >
                {shapeList.map((shape) => (
                  <Option
                    key={`shape_${shape._id}`}
                    value={`shape_${shape._id}`}
                    label={shape.name}
                  >
                    <div className="option-tag">{shape.name}</div>
                  </Option>
                ))}
                {model3dList.map((model3d) => (
                  <Option
                    key={`model3d_${model3d._id}`}
                    value={`model3d_${model3d._id}`}
                    label={model3d.name}
                  >
                    <div className="option-tag">{model3d.name}</div>
                  </Option>
                ))}
              </Select>

              {errors && errors.errors && errors.errors.locations && (
                <span className="error-message">
                  {errors.errors.locations[0].msg}
                </span>
              )}
            </div>
          ) : (
            <div className="form">
              <label className="form-label">Location</label>
              <Input
                placeholder="POI Location"
                className={`${
                  errors && errors.errors && errors.errors.location
                    ? 'has-error'
                    : ''
                }`}
                name="location"
                value={poi.location}
                onChange={onChangeHandler}
              />
              {errors && errors.errors && errors.errors.location && (
                <span className="error-message">
                  {errors.errors.location[0].msg}
                </span>
              )}
            </div>
          )}

          <div className="form">
            <label className="form-label">Operating Hours</label>
            <Input
              placeholder="POI Operating Hours"
              className={`${
                errors && errors.errors && errors.errors.opentime
                  ? 'has-error'
                  : ''
              }`}
              name="opentime"
              value={poi.opentime}
              onChange={onChangeHandler}
            />
            {errors && errors.errors && errors.errors.opentime && (
              <span className="error-message">
                {errors.errors.opentime[0].msg}
              </span>
            )}
          </div>

          <div className="form">
            <label className="form-label">Scheduling:</label>
            <div style={{ display: 'flex', gap: '8px' }}>
              <DatePicker
                allowClear
                style={{ width: '100%' }}
                placeholder="Start Date"
                format="DD/MM/YYYY"
                value={poi.start ? dayjs(poi.start) : null}
                onChange={(date) =>
                  handleChangeDate([date, poi.end ? dayjs(poi.end) : null])
                }
              />
              <DatePicker
                allowClear
                style={{ width: '100%' }}
                placeholder="End Date"
                format="DD/MM/YYYY"
                value={poi.end ? dayjs(poi.end) : null}
                onChange={(date) =>
                  handleChangeDate([poi.start ? dayjs(poi.start) : null, date])
                }
              />
            </div>
            {/* <Select
              onChange={(value) => handleChangeType(value)}
              value={type}
              defaultValue="all"
            >
              <Select.Option value="all">All Day</Select.Option>
              <Select.Option value="day">Day</Select.Option>
              <Select.Option value="date">Date</Select.Option>
            </Select> */}
          </div>
        </div>
        <div>
          <div className="form">
            <label className="form-label">Logo</label>
            {imagePreviewUrl ? (
              <div className="upload-image-preview">
                <Tooltip placement="top" title="Delete">
                  <button
                    type="button"
                    onClick={handleDeletePreviewImage}
                    className="btn-remove"
                  >
                    <i className="feather-x" />
                  </button>
                </Tooltip>
                <img
                  className="media-avatar"
                  src={imagePreviewUrl}
                  alt="User profile logo preview"
                />
              </div>
            ) : (
              <Upload
                accept="image/*"
                showUploadList={false}
                beforeUpload={onFileChangedHandler}
              >
                <div
                  onDragLeave={() => setIsDragged(false)}
                  onDragOver={() => setIsDragged(true)}
                  className={`upload-drag-and-drop ${
                    isDragged ? 'active' : ''
                  }`}
                >
                  <ExportIcon size={22} color="#C2C2C2" />
                  <p className="upload-title">
                    Drag or <span className="upload-highlight">Browse</span>
                  </p>
                  <p className="upload-subtitle">
                    File format supported: jpg, png (Up to 50MB){' '}
                  </p>
                </div>
              </Upload>
            )}
          </div>
          <div className="form">
            <label className="form-label">Description</label>
            <Input.TextArea
              rows={5}
              placeholder="POI Description"
              className={`${
                errors && errors.errors && errors.errors.description
                  ? 'has-error'
                  : ''
              }`}
              name="description"
              value={poi.description}
              onChange={onChangeHandler}
            />
            {errors && errors.errors && errors.errors.description && (
              <span className="error-message">
                {errors.errors.description[0].msg}
              </span>
            )}
          </div>
          <div className="form">
            <label className="form-label">Media Content 1</label>
            <Upload
              listType="picture-card"
              accept="image/*,video/mp4"
              beforeUpload={(file) =>
                onFileListChangedHandler({
                  file,
                  params: 'firstFileList',
                  setList: setFirstList,
                  list: firstList,
                })
              }
              onChange={({ fileList }) =>
                handleChange({ fileList, setPreview: setPreviewList })
              }
              onPreview={handlePreview}
              onRemove={(e) =>
                handleRemove({
                  e,
                  params: 'firstFileList',
                  poiParams: 'firstMedias',
                  setList: setFirstList,
                  list: firstList,
                })
              }
              fileList={previewList}
            >
              <div>
                <i className="feather-upload" />
                <div style={{ marginTop: 8 }}>Upload</div>
              </div>
            </Upload>
          </div>
          <div className="form">
            <label className="form-label">Media Content 2</label>
            <Upload
              listType="picture-card"
              accept="image/*,video/mp4"
              beforeUpload={(file) =>
                onFileListChangedHandler({
                  file,
                  params: 'secondFileList',
                  setList: setSecondList,
                  list: secondList,
                })
              }
              onChange={({ fileList }) =>
                handleChange({ fileList, setPreview: setSecondPreviewList })
              }
              onPreview={handlePreview}
              onRemove={(e) =>
                handleRemove({
                  e,
                  params: 'secondFileList',
                  poiParams: 'secondMedias',
                  setList: setSecondList,
                  list: secondList,
                })
              }
              fileList={secondPreviewList}
            >
              <div>
                <i className="feather-upload" />
                <div style={{ marginTop: 8 }}>Upload</div>
              </div>
            </Upload>
            <Modal
              visible={previewVisible}
              title={previewTitle}
              footer={null}
              onCancel={handleCancel}
            >
              <img
                alt="poi images"
                style={{ width: '100%' }}
                src={previewImage}
              />
            </Modal>
          </div>
          <div className="form">
            <label className="form-label">Phone</label>
            <Input
              placeholder="POI Phone"
              className={`${
                errors && errors.errors && errors.errors.phone
                  ? 'has-error'
                  : ''
              }`}
              name="phone"
              value={poi.phone}
              onChange={onChangeHandler}
            />
            {errors && errors.errors && errors.errors.phone && (
              <span className="error-message">
                {errors.errors.phone[0].msg}
              </span>
            )}
          </div>
          <div className="form">
            <label className="form-label">URL</label>
            <Input
              placeholder="POI URL"
              className={`${
                errors && errors.errors && errors.errors.url ? 'has-error' : ''
              }`}
              name="url"
              value={poi.url}
              onChange={onChangeHandler}
            />
            {errors && errors.errors && errors.errors.url && (
              <span className="error-message">{errors.errors.url[0].msg}</span>
            )}
          </div>
        </div>
      </form>
      <div
        className="button-wrapper"
        style={{ display: 'flex', justifyContent: 'flex-end' }}
      >
        <div>
          {loading ? (
            <button className="button-primary" disabled>
              Loading...
            </button>
          ) : (
            <button className="btn-primary" onClick={onSubmitHandler}>
              Submit
            </button>
          )}
          {/* <button className="button-secondary" onClick={handleReset}>
            Reset
          </button> */}
        </div>
      </div>
    </div>
  );
};

PoiForm.propTypes = {
  poiData: PropTypes.shape({
    name: PropTypes.string,
    phone: PropTypes.string,
    priority: PropTypes.string,
    description: PropTypes.string,
    logo: PropTypes.string,
    opentime: PropTypes.string,
    url: PropTypes.string,
    category: PropTypes.string,
    siteId: PropTypes.string,
    tag: PropTypes.string,
    location: PropTypes.string,
    floor: PropTypes.string,
    modifiedAt: PropTypes.string,
    modifiedBy: PropTypes.string,
  }),
  action: PropTypes.func.isRequired,
};

export default PoiForm;
